import { render, staticRenderFns } from "./group.vue?vue&type=template&id=e840e360&scoped=true"
import script from "./group.vue?vue&type=script&lang=ts"
export * from "./group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e840e360",
  null
  
)

export default component.exports